export default {
    title: "家",
    button: {
        accessories: "浏览目录"
    },
    noAvailableItems: "外围门户目前没有任何适用于您所在国家/地区的项目。请与您的经理合作采购您需要的物品。<br><br><a href='#' role='button' data-widget-trigger='{widgetOptions}'>联系支持</a>",
    error: "检索产品时出现问题。请刷新浏览器。"
}